import { breakpoints } from "@brightagency/headstart-common";
import CreateRoundedIcon from "@mui/icons-material/CreateRounded";
import { transparentize } from "polished";
import React, { FC } from "react";
import styled from "styled-components";
import { colors } from "../../../../../../utils/colors";

export const Inner = styled.div`
    padding: 16px 0;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;

    > *:first-child {
        margin-right: 16px;
    }
`;

export const Outer = styled.button`
    padding: 0;
    border: 0;
    background: none;
    margin: 0;
    text-align: left;
    color: ${colors.brandDark};

    &:hover {
        cursor: pointer;
        color: ${colors.brandMid};
    }

    &:not(:last-child) > ${Inner} {
        border-bottom: 1px solid ${transparentize(0.9, "black")};
    }

    ${breakpoints.medium} {
        > ${Inner} {
            border-bottom: 0 !important;
        }
    }
`;

export const Question = styled.div`
    margin-bottom: 4px;
    font-size: 14px;
`;

export const Answer = styled.div`
    font-weight: bold;
    font-size: 14px;
`;

export const Response: FC<{ question: string; response: string; onEdit: () => void }> = props => {
    return (
        <Outer onClick={props.onEdit}>
            <Inner>
                <div>
                    <Question>{props.question}</Question>
                    <Answer>{props.response}</Answer>
                </div>
                <CreateRoundedIcon htmlColor={colors.brandMid} />
            </Inner>
        </Outer>
    );
};
